"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_router_dom_1 = require("react-router-dom");
var common_1 = require("@/components/common");
var Button_component_1 = require("@/components/common/Button/Button.component");
var Styled = __importStar(require("./ErrorPage.styled"));
var constants_1 = require("@/constants");
var minsour_dori_248_svg_1 = __importDefault(require("@/assets/svg/minsour-dori-248.svg"));
var ErrorPage = function (_a) {
    var path = _a.path;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var handleNavigateApplicationList = function () {
        navigate(constants_1.PATH.APPLICATION);
    };
    return ((0, jsx_runtime_1.jsx)(Styled.ErrorPageWrapper, { children: (0, jsx_runtime_1.jsxs)(Styled.ErrorPageContainer, { children: [(0, jsx_runtime_1.jsx)(minsour_dori_248_svg_1.default, {}, void 0), (0, jsx_runtime_1.jsx)(Styled.Title, { children: path === constants_1.PATH.NOT_FOUND
                        ? '길을 잘못 들었구나.. 돌아가..'
                        : '접근 권한이 없는 팀이구나.. 돌아가..' }, void 0), (0, jsx_runtime_1.jsx)(common_1.Button, { shape: Button_component_1.ButtonShape.primary, label: "\uC9C0\uC6D0\uC11C\uB0B4\uC5ED\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30", onClick: handleNavigateApplicationList }, void 0)] }, void 0) }, void 0));
};
exports.default = ErrorPage;
